import { SxProps, Theme } from "@mui/material";

export const DashboardCardStyle: SxProps = {
  boxShadow: "0px 1px 3px 0px #0000001A",
  p: 2,
  minHeight: "170px",
  bgcolor: "#FFFFFF",
  borderRadius: "16px",
};

export const tooltipCardSx: SxProps<Theme> = {
  px: 1.5,
  py: 1,
  borderRadius: 2,
  boxShadow: "0px 10px 25px rgba(15, 23, 42, 0.15)",
  bgcolor: "#fff",
  border: "1px solid #F3F4F6",
  position: "relative",
  "&::before": {
    content: "''",
    position: "absolute",
    bottom: -7,
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "7px solid transparent",
    borderRight: "7px solid transparent",
    borderTop: "7px solid #F3F4F6",
    zIndex: 0,
  },
  "&::after": {
    content: "''",
    position: "absolute",
    bottom: -6,
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid #fff",
    zIndex: 1,
  },
};

export const axisTickStyle = { fill: "#6B7280", fontSize: 12 };
